import { notification } from 'antd';
import codeMessage from './codeMessage';

// Global Lock: Prevents multiple parallel redirects
let isAuthRedirecting = false;

const errorHandler = (error) => {
  const { response } = error;

  if (response && response.status) {
    const { status, data } = response;
    const message = data && data.message;
    const errorText = message || codeMessage[status];

    // Check for 401 Unauthorized or the jwtExpired flag
    if (status === 401 || (data && data.jwtExpired)) {

      if (!isAuthRedirecting) {
        isAuthRedirecting = true;

        // 1. Immediately clear storage to stop components from re-triggering requests
        window.localStorage.clear();

        notification.error({
          message: 'Session Expired',
          description: 'Your session has ended. Redirecting to login...',
          duration: 5,
        });

        // 2. Use location.replace to break the back-button history loop
        setTimeout(() => {
          window.location.replace('/login');
        }, 1500);
      }

      return data;
    }

    // Standard error handling for non-auth errors
    notification.config({ duration: 10 });
    notification.error({
      message: `Request failed`,
      description: errorText,
    });

    return data;

  } else {
    // Network Error logic
    notification.config({ duration: 5 });
    notification.error({
      message: 'No internet connection',
      description: 'Cannot connect to the server. Please check your network.',
    });

    return {
      success: false,
      message: 'Cannot connect to the server',
    };
  }
};

export default errorHandler;